module.exports = __webpack_public_path__ + "img/Anhänger_7t.257ab47d.svg";